import { apiClient } from './client'
import type { CaseOwnerView } from '../types/caseOwner'

/**
 * IB-335 — typed fetch wrappers for the Case Owner ownership/visibility attribute
 * (`GET`/`POST /api/v1/cases/{caseId}/owner`), same thin-wrapper convention as `api/caseTeam.ts`.
 * The read may come back masked (`ownerUserId`/`ownerName` both `null`) per `CaseOwnerView`'s own
 * contract — this wrapper never guesses or fills that in, it echoes the server's decision verbatim.
 */

export async function getCaseOwner(caseId: string, signal?: AbortSignal): Promise<CaseOwnerView> {
  const { data } = await apiClient.get<CaseOwnerView>(`/cases/${caseId}/owner`, { signal })
  return data
}

export async function assignCaseOwner(caseId: string, ownerUserId: string): Promise<CaseOwnerView> {
  const { data } = await apiClient.post<CaseOwnerView>(`/cases/${caseId}/owner`, { ownerUserId })
  return data
}
